import {SEARCH_TERM_CHANGE, SEARCH_TERM_CHANGE_DONE, SORT_BY_CHANGE} from '../actions/ImageActions';

const GALLERY_SETTINGS_KEY = 'gallerySettings';

const initialState = JSON.parse(localStorage.getItem(GALLERY_SETTINGS_KEY)) || {
    searchInputValue: '',
    searchTerm: '',
    sortBy: 'uploadTime.desc',
};

function myImagesSettingsInternal(state, action) {
    switch (action.type) {
        case SORT_BY_CHANGE:
            return {...state, sortBy: action.sortBy};
        case SEARCH_TERM_CHANGE:
            return {...state, searchInputValue: action.searchInputValue};
        case SEARCH_TERM_CHANGE_DONE:
            return {...state, searchTerm: action.searchTerm, searchInputValue: action.searchTerm};
        default:
            break;
    }
    return state;
}

export function myImagesSettings(state = initialState, action) {
    const newState = myImagesSettingsInternal(state || initialState, action);
    if (newState !== state) {
        localStorage.setItem(GALLERY_SETTINGS_KEY, JSON.stringify(newState));
    }
    return newState;
}

export const getSearchTerm = state => state.myImagesSettings.searchTerm;
export const getSortBy = state => state.myImagesSettings.sortBy;



// WEBPACK FOOTER //
// ./src/reducers/myImagesSettings.js